import { NewAdmin } from 'components/InviteAdminModal/views/NewAdmin';
import { NewAdminLocations } from 'components/InviteAdminModal/views/NewAdminLocations';

export const InviteAdminModalComponentMap = {
  New: NewAdmin,
  Locations: NewAdminLocations,
};

export type InviteAdminModalViewType = keyof typeof InviteAdminModalComponentMap;
